import { useQuery } from '@apollo/client';
import { cost_version_status_enum, scenario_version_status_enum } from '@predium/enums';
import { useMemo } from 'react';
import { GET_SCENARIO } from '../../../../graphql/ActionPlanning.queries';

export function useQueryGetScenario(scenarioId: number) {
  const { data, loading } = useQuery(GET_SCENARIO, {
    skip: Number.isNaN(scenarioId),
    variables: { scenario_id: scenarioId },
    fetchPolicy: 'cache-and-network',
  });

  const activeScenarioVersion = useMemo(() => {
    return data?.getScenario?.scenario_versions.find(
      (version) => version.status === scenario_version_status_enum.ACTIVE,
    );
  }, [data]);

  const isOnLatestCostVersion = useMemo(() => {
    return activeScenarioVersion?.cost_version?.status === cost_version_status_enum.ROLLED_OUT;
  }, [activeScenarioVersion]);

  return {
    scenario: data?.getScenario,
    isLoadingScenario: loading,
    activeScenarioVersion,
    isOnLatestCostVersion,
  };
}
